export const configuration = {
	exampleVinPicture: {
		warta: 'example-vin-warta.jpg',
		default: 'example-vin.jpg',
	},
	exampleOverallDashboardImage: {},
	exampleWindshieldImage: {},
	editIcon: {
		link4: 'photo',
		warta: 'photo',
		compensa: 'photo',
		interrisk: 'photo',
		controlexpert: 'photo',
		pzu: 'photo',
		allianzeu: 'photo',
		default: 'photo', //"pen"
	},
};

export function getConfiguration(
	parameter: keyof typeof configuration,
	customerName: string | null | undefined
) {
	const options = configuration[parameter];

	const optionsTypes = Object.getOwnPropertyNames(options);
	const customerNameNotNull = customerName?.toLocaleLowerCase() || '';
	const customerParam = optionsTypes.includes(customerNameNotNull)
		? customerNameNotNull
		: 'default';

	const configurationValue = configuration[parameter][customerParam];

	return configurationValue;
}
